import _ from 'lodash';
import { t } from 'ttag';

const SHIPPING_ENUM = {
  FIRST_EDIT_SENDER: 'FIRST_EDIT_SENDER',
  FIRST_EDIT_RECIPIENT: 'FIRST_EDIT_RECIPIENT',
  SENDER: 'SENDER',
  RECIPIENT: 'RECIPIENT',
};

const MISSING_FIELD_LIST = {
  SENDER_EMAIL: t`Sender email`,
  RECIPIENT_EMAIL: t`Recipient email`,
  RECIPIENT_PHONE: t`Recipient phone number`,
};

const DEFAULT_CONTACT = {
  name: '',
  street1: '',
  street2: '',
  city: '',
  country: '',
  state: '',
  zip: '',
  phone: '',
  email: '',
  company: '',
};

/**
 * Lookup of the contact form field names, keyed by themselves. Derived by mapping DEFAULT_CONTACT with _.mapValues so every value is replaced by its own key, letting inputs reference field names without string literals.
 *
 * @returns An object whose values equal their DEFAULT_CONTACT keys.
 */
const CONTACT_KEY = _.mapValues(DEFAULT_CONTACT, (value, key) => key);

const DEFAULT_DIMENSIONS = {
  length: 12.5,
  width: 9.5,
  height: 1,
  weight: 1,
  distanceUnit: 'in',
  weightUnit: 'lb',
};

export { CONTACT_KEY, DEFAULT_CONTACT, MISSING_FIELD_LIST, SHIPPING_ENUM, DEFAULT_DIMENSIONS };
